module.exports = __webpack_public_path__ + "img/left03-1.5082f2cf.png";